import { render, staticRenderFns } from "./DiagnosticList.vue?vue&type=template&id=16622c70&"
import script from "./DiagnosticList.vue?vue&type=script&lang=js&"
export * from "./DiagnosticList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports